if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true' && !this.closest('#Product-Drawer');
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
      this.originalSlides = null; // Add this property
    }
    
    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();

      this.updateMedia();
      this.startGemstoneLabelsInterval();
      //this.updateProductTitle();
      this.restoreSelectionsFromUrl();
      this.initializeMetalTypeLinks();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateProductTitle();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput(); // IOTR 2026-10-06: re-enabled so the selected carat/stone variant reaches the cart
        this.renderProductInfo();
        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    // Function to get current selections
    getCurrentSelections() {
      const selections = {};
      
      // Get Carat Weight selection
      const caratWeightFieldset = document.querySelector('fieldset[data-handle="carat-weight"]');
      if (caratWeightFieldset) {
        const checkedCaratInput = caratWeightFieldset.querySelector('input[type="radio"]:checked');
        if (checkedCaratInput) {
          selections.caratWeight = checkedCaratInput.value;
        }
      }
      
      // Get Center Gemstone selection
      const centerGemstoneFieldset = document.querySelector('fieldset[data-handle="center-gemstone"]');
      if (centerGemstoneFieldset) {
        const checkedGemstoneInput = centerGemstoneFieldset.querySelector('input[type="radio"]:checked');
        if (checkedGemstoneInput) {
          selections.centerGemstone = checkedGemstoneInput.value;
        }
      }
      
      return selections;
    }

    // Function to save selections to URL parameters
    saveSelectionsToUrl(url) {
      const selections = this.getCurrentSelections();
      const urlObj = new URL(url, window.location.origin);
      
      if (selections.caratWeight) {
        urlObj.searchParams.set('carat', encodeURIComponent(selections.caratWeight));
      }
      if (selections.centerGemstone) {
        urlObj.searchParams.set('gemstone', encodeURIComponent(selections.centerGemstone));
      }
      
      return urlObj.toString();
    }

    // Function to restore selections from URL parameters
    restoreSelectionsFromUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      const caratWeight = urlParams.get('carat');
      const centerGemstone = urlParams.get('gemstone');
      
      let selectionsRestored = false;
      
      // Use a slight delay to ensure the DOM is fully ready
      setTimeout(() => {
        if (caratWeight) {
          const caratWeightFieldset = document.querySelector('fieldset[data-handle="carat-weight"]');
          if (caratWeightFieldset) {
            const caratInput = Array.from(caratWeightFieldset.querySelectorAll('input[type="radio"]'))
              .find(input => input.value === decodeURIComponent(caratWeight));
            if (caratInput) {
              caratInput.checked = true;
              // Trigger multiple events to ensure variant updates
              caratInput.dispatchEvent(new Event('change', { bubbles: true }));
              caratInput.dispatchEvent(new Event('click', { bubbles: true }));

              selectionsRestored = true;
            }
          }
        }
        
        if (centerGemstone) {
          const centerGemstoneFieldset = document.querySelector('fieldset[data-handle="center-gemstone"]');
          if (centerGemstoneFieldset) {
            const gemstoneInput = Array.from(centerGemstoneFieldset.querySelectorAll('input[type="radio"]'))
              .find(input => input.value === decodeURIComponent(centerGemstone));
            if (gemstoneInput) {
              gemstoneInput.checked = true;
              // Trigger multiple events to ensure variant updates
              gemstoneInput.dispatchEvent(new Event('change', { bubbles: true }));
              gemstoneInput.dispatchEvent(new Event('click', { bubbles: true }));
              selectionsRestored = true;
            }
          }
        }
        
        // Manually trigger variant update if your component has such a method
        if (selectionsRestored) {
          if (typeof this.updateOptions === 'function') {
            this.updateOptions();
          }
          if (typeof this.onVariantChange === 'function') {
            this.onVariantChange();
          }
        }
        
        // Clean the URL if selections were restored
        if (selectionsRestored && (caratWeight || centerGemstone)) {
          const cleanUrl = window.location.pathname;
          //window.history.replaceState({}, document.title, cleanUrl);
        }
      }, 200); // Delay to ensure DOM is ready
    }

    // Function to get current page title
    getCurrentPageTitle() {
      const activeMetalLink = document.querySelector('.metal_type-custom .select-option.active a');
      return activeMetalLink ? activeMetalLink.getAttribute('title') : null;
    }

    // Function to add click listeners to metal type links
    initializeMetalTypeLinks() {
      const metalLinks = document.querySelectorAll('.metal_type-custom .select-option a');
      const currentPageTitle = this.getCurrentPageTitle();
      
      metalLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          const targetTitle = link.getAttribute('title');
          
          // Only preserve selections if the titles match
          if (!link.closest('#Product-Drawer') && currentPageTitle && targetTitle && currentPageTitle === targetTitle) {
            e.preventDefault();
            const originalUrl = link.getAttribute('href');
            const urlWithSelections = this.saveSelectionsToUrl(originalUrl);
            window.location.href = urlWithSelections;
          }
          // If titles don't match, let the link navigate normally (don't prevent default)
        });
      });
    }
    
    /*startGemstoneLabelsInterval() {
      // Check every 100ms until labels are found or timeout is reached
      let attempts = 0;
      const maxAttempts = 25; // 5 seconds max
      
      const checkInterval = setInterval(() => {
        const labels = document.querySelectorAll('[data-name="Center Gemstone"] + ul li > label');
        //const labels = document.querySelectorAll('[data-name="Center Gemstone"] + ul li label + .gcw-txt--variant');
        console.log('Checking for labels, found:', labels.length);
        
        attempts++;
        
        if (labels.length > 0 && !this.customDivsAdded) {
          this.addCustomDivsToGemstoneLabels(labels);
          this.updateProductTitle();
          this.customDivsAdded = true; 
          clearInterval(checkInterval);
        } else if (attempts >= maxAttempts) {
          // Timeout reached
          clearInterval(checkInterval);
        }
      }, 100);
    }*/
    startGemstoneLabelsInterval() {
      // Check every 100ms until labels are found or timeout is reached
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max
      
      const checkInterval = setInterval(() => {
        // Check for the center gemstone fieldset and its labels
        const centerGemstoneFieldset = document.querySelector('fieldset[data-handle="center-gemstone"]');
        const labels = centerGemstoneFieldset ? centerGemstoneFieldset.querySelectorAll('input[type="radio"] + label') : [];
                
        attempts++;
        
        if (labels.length > 0 && !this.customDivsAdded) {
          this.addCustomDivsToGemstoneLabels(labels);
          this.updateProductTitle();
          this.customDivsAdded = true; 
          clearInterval(checkInterval);
        } else if (attempts >= maxAttempts) {
          // Timeout reached - still try to update title if possible
          console.log('Timeout reached while waiting for gemstone labels');
          this.updateProductTitle();
          clearInterval(checkInterval);
        }
      }, 100);
    }
    updateProductTitle() {
      if (!this.currentVariant) return;
      
      let baseProductName = this.currentVariant.name.split(' - ')[0];
      let formattedOptions = [];
      const root = this.closest('#Product-Drawer') || document;
      
      // Option 1: Metal Type - Get from active metal selection
      const activeMetal = root.querySelector('.metal_type-custom .select-option.active[data-metal-name]');
      if (activeMetal) {
        const metalName = activeMetal.getAttribute('data-metal-name');
        if (metalName) {
          // Skip Metal Type from title as per your original logic
          // If you want to include it, uncomment the next line:
          if(metalName === "Rose Gold" || metalName === "White Gold" || metalName === "Yellow Gold") {
            formattedOptions.push("18k " + metalName);
          } else {
            formattedOptions.push(metalName);
          }
        }
      }
      
      // Option 2: Carat Weight - Get from checked radio button label
      const caratWeightFieldset = root.querySelector('fieldset[data-handle="carat-weight"]');
      if (caratWeightFieldset) {
        const checkedCaratInput = caratWeightFieldset.querySelector('input[type="radio"]:checked');
        if (checkedCaratInput) {
          const caratLabel = caratWeightFieldset.querySelector(`label[for="${checkedCaratInput.id}"] span`);
          const caratOptionPrice = caratWeightFieldset.querySelector(`label[for="${checkedCaratInput.id}"] [data-option-price]`);
          if (caratLabel) {
            const caratValue = caratLabel.textContent.trim();
            if (caratValue) {
              formattedOptions.push(caratValue);
              // Update the carat weight display
              const selectCaratElements = document.querySelectorAll('span.select_carat');
              selectCaratElements.forEach(element => {
                element.textContent = caratValue;
              });
              // Update gemstone prices based on selected carat
              this.updateGemstonePrices(caratValue);
            }
          }
        }
      }
      
      // Option 3: Center Gemstone - Get from checked radio button's option_title
      const centerGemstoneFieldset = root.querySelector('fieldset[data-handle="center-gemstone"]');
      if (centerGemstoneFieldset) {
        const checkedGemstoneInput = centerGemstoneFieldset.querySelector('input[type="radio"]:checked');
        if (checkedGemstoneInput) {
          const gemstoneLabel = centerGemstoneFieldset.querySelector(`label[for="${checkedGemstoneInput.id}"]`);
          if (gemstoneLabel) {
            const optionTitle = gemstoneLabel.querySelector('.option_title');
            if (optionTitle) {
              const gemstoneValue = optionTitle.textContent.trim();
              // Skip if it contains "No thanks" (case insensitive)
              if (gemstoneValue && !gemstoneValue.toLowerCase().includes('no thanks')) {
                formattedOptions.push(gemstoneValue);
              }
            }
          }
        }
      }
      
      const selectionsText = formattedOptions.join(', ');


      // const settingStyle = baseProductName.split(" | ")[1];
      // const title = baseProductName.split(" | ")[0];

      // this.formattedProductTitle = `${settingStyle ? `<span class="product-title--selection-text product-title--setting-style">${settingStyle.toUpperCase()}</span> `: ""}${title} ${selectionsText ? `<span class="product-title--selection-text">${selectionsText}</span>` : ""}`;
      
      const selectionsTextEl = root.querySelector('.product-title .product-title--selection-text');
      if (selectionsTextEl) {
        if(selectionsText) {
          selectionsTextEl.textContent = selectionsText;
        } else {
          selectionsTextEl.style.display = "none";
        }
      }
  
    }

    // Helper function to format price from cents to dollars
    formatPrice(cents) {
      const dollars = cents / 100;
      const formatted = dollars.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return '$' + formatted;
    }

    // Helper function to get variant by matching options
    getVariantByOptions(option1Value, option2Value) {
      return this.getVariantData().find(variant => {
        return variant.option1 === option1Value && variant.option2 === option2Value;
      });
    }

    // Update all gemstone prices based on selected carat
    updateGemstonePrices(selectedCarat) {
      const root = this.closest('#Product-Drawer') || document;
      const basePrice = Math.min(...this.getVariantData().map((variant) => variant.price));

      // Find all gemstone radio inputs in the Center Gemstone fieldset
      const centerGemstoneFieldset = root.querySelector('fieldset[data-handle="center-gemstone"]');
      if (!centerGemstoneFieldset) return;
      
      const radioInputs = centerGemstoneFieldset.querySelectorAll('input[type="radio"]');
      
      radioInputs.forEach(input => {
        const gemstoneType = input.value;
        const label = root.querySelector(`label[for="${input.id}"]`);

        // Skip "No Thanks" option
        if (label && gemstoneType !== "No Thanks I don't need gemstone" && !gemstoneType.toLowerCase().includes('no thanks')) {
          const priceSpan = label.querySelector('.gemstone_price');
          const subValueSpan = label.querySelector('.sub_value');
          
          const variant = this.getVariantByOptions(selectedCarat, gemstoneType);
          var default_sub_title = '';
          if(gemstoneType == 'Lab Diamond'){
            default_sub_title = 'F color, VS1 clarity';
          }
          if(gemstoneType == 'Natural Diamond'){
            default_sub_title = 'G color, SI1 clarity';
          }
          if(gemstoneType == 'Moissanite'){
            default_sub_title = 'Forever One';
          }

          // When the gemstone comparison modal is on the page it publishes
          // window.IOTRGemstoneGrades (snippets/iotr-gemstone-compare.liquid) —
          // the single source of truth for grades. Swatch sublabels MUST read
          // from it so they can never contradict the modal. Variant metafield
          // sub_titles are ignored for the three stones in that case.
          var sharedGrades = window.IOTRGemstoneGrades;
          var sharedSubTitle = '';
          if (sharedGrades) {
            if (gemstoneType === 'Lab Diamond') sharedSubTitle = sharedGrades.lab;
            if (gemstoneType === 'Natural Diamond') sharedSubTitle = sharedGrades.natural(selectedCarat);
            if (gemstoneType === 'Moissanite') sharedSubTitle = sharedGrades.moissanite;
          }

          if (variant) {
            if (priceSpan) {
              const priceDifference = variant.price - basePrice;
              priceSpan.textContent = this.formatPrice(priceDifference);
            }

            if (subValueSpan && window.variantMetafields) {
              const metafieldKey = `${variant.id}-wep`;
              const metafields = window.variantMetafields[metafieldKey];

              if (sharedSubTitle) {
                subValueSpan.textContent = sharedSubTitle;
              } else if (metafields && metafields.sub_title) {
                //subValueSpan.textContent = `${selectedCarat} ${metafields.sub_title}`;
                subValueSpan.textContent = `${metafields.sub_title}`;
              } else {
                //subValueSpan.textContent = `${selectedCarat} ${default_sub_title}`;
                subValueSpan.textContent = `${default_sub_title}`;
              }
              const icon = label.querySelector('.icon > img')
              const gid = metafields?.gem_swatch;
              if (gid && icon) {
                // Save original src on first change
                if (!icon.hasAttribute('data-prev-src')) {
                  icon.setAttribute('data-prev-src', icon.src);
                }
                icon.src = gid;
              } else if (icon && icon.hasAttribute('data-prev-src')) {
                // Revert to original if no gid
                icon.src = icon.getAttribute('data-prev-src');
              }
            }
          }
        }
      });
    }
    addCustomDivsToGemstoneLabels(labels) {
       const metalTypeLegend = document.querySelector('legend.name-option[data-name="Metal Type"]');
  
        if (metalTypeLegend) {
          // Get the parent element of the legend
          const parentElement = metalTypeLegend.parentElement;
          parentElement.classList.add('option-metal_type');
          
          // Check if the element already exists to avoid adding it twice
          const existingElement = parentElement.querySelector('.different-metal_type');
          
          if (!existingElement) {
            // Create the new div element with all its contents
            const newDiv = document.createElement('div');
            newDiv.className = 'different-metal_type';
            newDiv.innerHTML = `
              <modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-metal-type">
                <button id="ProductPopup-metal-type" class="product-popup-modal__button" type="button" aria-haspopup="dialog">More Info</button>
              </modal-opener>
            `;
            
            // Append the new div to the parent element
            parentElement.appendChild(newDiv);
          }
        }
      // Keywords to look for and extract
      const keywords = ["Mined Diamond", "Lab Diamond", "Moissanite", "No thanks"];
      
      // Custom content for each keyword
      const customDivs = [
        {'Mined Diamond':`<div class="mined-diamond_content">
                            <modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-option_popup_2">
                              <button id="ProductPopup-option_popup_2" class="product-popup-modal__button" type="button" aria-haspopup="dialog">
                                <span class="icon-popup"></span>
                              </button>
                            </modal-opener>
                          </div>`},
        {'Lab Diamond':`<div class="labe-diamond_content"><span class="btn">Most Popular</span><modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-option_popup_1">
      <button id="ProductPopup-option_popup_1" class="product-popup-modal__button" type="button" aria-haspopup="dialog"><span class="icon-popup"></span></button>
    </modal-opener></div>`},
        {'Moissanite':`<div class="moissanite_content"><modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-option_popup_3">
      <button id="ProductPopup-option_popup_3" class="product-popup-modal__button" type="button" aria-haspopup="dialog"><span class="icon-popup"></span></button>
    </modal-opener></div>`},
        {'No thanks':`<div class="nothanks_content"></div>`}
      ];

      const different_shape = `<div class="different-shape_button">
                                <modal-opener class="product-popup-modal__opener no-js-hidden" data-modal="#PopupModal-different-shape">
                                  <button id="ProductPopup-different-shape" class="product-popup-modal__button" type="button" aria-haspopup="dialog">Want this ring with a different shape or center carat weight?</button>
                                </modal-opener>
                              </div>`;
      
      const observer = new MutationObserver(() => {
        const globoWatchesDiv = document.querySelector('.globo-swatch-product-detail');
        //const globoWatchesDiv = document.querySelector('[data-handle="center-gemstone"]');
        if (globoWatchesDiv && !document.querySelector('.different-shape_button')) {
          globoWatchesDiv.insertAdjacentHTML('beforeend', different_shape);
          observer.disconnect();
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    
      function toClassName(str) {
        return str.toLowerCase().replace(/\s+/g, '-');
      }
      
      function wrapTextNodesWithSpan(element) {
        const childNodes = Array.from(element.childNodes);
        
        childNodes.forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim() !== '') {
            const span = document.createElement('span');
            span.style.display = 'none';
            
            node.parentNode.insertBefore(span, node);
            span.appendChild(node);
          }
        });
      }
    
      labels.forEach(label => {
        const attrTitleElements = label.querySelectorAll('.attr-title-hover');
        attrTitleElements.forEach(element => {
          element.classList.remove('attr-title-hover');
          element.classList.add('gemstone-spec');
        });
      });
    
      labels.forEach(label => {
        const specElement = label.querySelector('.gemstone-spec');
        
        if (specElement) {
          const specText = specElement.textContent;
          
          const priceRegex = /(\+\$\d+(?:\.\d+)?)/;
          const priceMatch = specText.match(priceRegex);
          
          if (priceMatch) {
            const price = priceMatch[0];
            
            specElement.textContent = specText.replace(priceRegex, '').trim();
            
            const priceSpan = document.createElement('span');
            priceSpan.className = 'gemstone-price';
            priceSpan.textContent = price;
            
            if (specElement.nextSibling) {
              label.insertBefore(priceSpan, specElement.nextSibling);
            } else {
              label.appendChild(priceSpan);
            }
          }
        }
      });
    
      labels.forEach((label) => {
        const hoverElement = label.querySelector('.gemstone-spec');
        
        if (hoverElement) {
          const hoverText = hoverElement.textContent;
          let foundKeyword = null;
          let matchingDivObj = null;
          
          for (let i = 0; i < keywords.length; i++) {
            const keyword = keywords[i];
            if (hoverText.includes(keyword)) {
              foundKeyword = keyword;
              matchingDivObj = customDivs[i];
              break;
            }
          }
          
          if (foundKeyword && matchingDivObj) {
            const divHTML = matchingDivObj[foundKeyword];
            
            // Check if this label already has our custom div
            const className = divHTML.match(/class="([^"]+)"/)[1];
            const existingDiv = label.querySelector(`.${className}`);
            
            if (!existingDiv) {
              const keywordSpan = document.createElement('span');
              keywordSpan.textContent = foundKeyword;
              keywordSpan.className = 'gemstone-type';
              keywordSpan.className = `gemstone-type ${toClassName(foundKeyword)}`;
              
              const container = document.createElement('div');
              container.innerHTML = divHTML;
              container.className = 'option_info';
              
              hoverElement.textContent = hoverElement.textContent.replace(foundKeyword, '');
              
              label.insertBefore(container, hoverElement);
              label.insertBefore(keywordSpan, hoverElement);
              
              wrapTextNodesWithSpan(label);
            }
          }
        }
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        //console.log('this is option: '+item.id+' - '+this.options[i])
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
      document.querySelectorAll('.atc-button-price-container').forEach((el)=>{
         this.currentVariant ? el.textContent = this.formatPrice(this.currentVariant.price) : '';
      })
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false' || this.closest('#Product-Drawer')) {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          //console.log('this is option: '+option)
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.productSlider) return;

      //console.log(this.currentVariant)
      
      let variantId = this.currentVariant.id;
      
      // Store original slides on first run if not already stored
      if (!this.originalSlides && this.productSlider.querySelectorAll('.product-images__slide').length > 0) {
        // Only store original slides if they aren't custom variant slides
        if (!this.productSlider.querySelector('.custom-variant-slide')) {
          this.originalSlides = Array.from(this.productSlider.querySelectorAll('.product-images__slide'));
        }
      }

      // Check if this variant has custom media in variantMetafields
      if (window.variantMetafields && 
          window.variantMetafields[variantId] && 
          Object.keys(window.variantMetafields[variantId]).length > 0) {
        
        // Hide all original slides if they exist
        if (this.originalSlides) {
          this.originalSlides.forEach(slide => {
            slide.style.display = 'none';
          });
        }
        
        // Remove any previously created custom slides
        const customSlides = this.productSlider.querySelectorAll('.custom-variant-slide');
        customSlides.forEach(slide => {
          slide.remove();
        });
        
        // Add new slides from variant metafields
        const variantMedia = window.variantMetafields[variantId];
        const section = this.dataset.section || '';
        let slideIndex = 0;
        
        // Create slides for each media item
        for (let key in variantMedia) {
          const media = variantMedia[key];
          slideIndex++;
          
          if (typeof media === 'string') {
            // This is an image URL
            this.addCustomImageSlide(this.productSlider, media, section, slideIndex, variantId);
          } else if (typeof media === 'object' && media.sources) {
            // This is a video
            this.addCustomVideoSlide(this.productSlider, media, section, slideIndex, variantId);
          }
        }
        
        // Reinitialize the slider
        if (typeof this.productSlider.reInit === 'function') {
          this.productSlider.reInit();
        } else if (Flickity && Flickity.data(this.productSlider)) {
          const flkty = Flickity.data(this.productSlider);
          flkty.reloadCells();
          flkty.resize();
        }
        
        dispatchCustomEvent('product:media-updated', {
          variantId: variantId
        });
        
        return; // Exit early since we've handled the media update
      } else {
        // No custom media for this variant, show original slides
        if (this.originalSlides) {
          // Show original slides and remove custom slides
          this.originalSlides.forEach(slide => {
            slide.style.display = '';
          });
          
          const customSlides = this.productSlider.querySelectorAll('.custom-variant-slide');
          customSlides.forEach(slide => {
            slide.remove();
          });
          
          // Reinitialize the slider
          if (typeof this.productSlider.reInit === 'function') {
            this.productSlider.reInit();
          } else if (Flickity && Flickity.data(this.productSlider)) {
            const flkty = Flickity.data(this.productSlider);
            flkty.reloadCells();
            flkty.resize();
          }
        }
      }
      
      // Default behavior for standard variants
      if (this.currentVariant.featured_media) {
        let mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        let activeMedia = this.productSlider.querySelector(mediaId);
        
        if (activeMedia) {
          if (this.thumbnails) {
            this.setActiveMediaSlider(mediaId, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider);
          } else {
            this.setActiveMedia(activeMedia);
          }
        }
      }
    }
    
    // Add new methods for creating custom slides
    addCustomImageSlide(sliderComponent, imageUrl, section, index, variantId) {
      const slideId = `Slide-${section}-${variantId}-${index}`;
      const slide = document.createElement('div');
      slide.id = slideId;
      slide.className = 'product-images__slide product-images__slide--image custom-variant-slide';
      
      const mediaWrapper = document.createElement('div');
      mediaWrapper.className = 'product-single__media product-single__media-image aspect-ratio aspect-ratio--adapt';
      mediaWrapper.style = '--padding-bottom: 100.0%;';
      
      const img = document.createElement('img');
      img.src = imageUrl;
      img.className = 'lazyautosizes ls-is-cached lazyloaded';
      img.loading = 'lazy';
      
      const zoomLink = document.createElement('a');
      zoomLink.href = imageUrl;
      zoomLink.className = 'product-single__media-zoom';
      zoomLink.dataset.msrc = imageUrl;
      zoomLink.dataset.w = '1200';
      zoomLink.dataset.h = '1200';
      zoomLink.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.375 4.0625H15.9375V7.625" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M11.7812 8.21875L15.9375 4.0625" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M7.625 15.9375H4.0625V12.375" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
<path d="M8.21875 11.7812L4.0625 15.9375" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
</svg>`;
      
      mediaWrapper.appendChild(img);
      mediaWrapper.appendChild(zoomLink);
      slide.appendChild(mediaWrapper);
      sliderComponent.appendChild(slide);
    }
    
    addCustomVideoSlide(sliderComponent, videoData, section, index, variantId) {
      const slideId = `Slide-${section}-${variantId}-${index}`;
      const slide = document.createElement('div');
      slide.id = slideId;
      slide.className = 'product-images__slide product-images__slide--video custom-variant-slide';
      
      const mediaWrapper = document.createElement('div');
      mediaWrapper.className = 'product-single__media product-single__media-video';
      
      const videoSource = videoData.sources[0];
      
      const videoContainer = document.createElement('div');
      videoContainer.className = 'product-single__media-external-video--play';
      
      const video = document.createElement('video');
      video.controls = true;
      video.muted = true;
      video.preload = 'metadata';
      video.className = 'product-single__media-video-element';
      
      const source = document.createElement('source');
      source.src = videoSource.url;
      source.type = videoSource.mime_type;
      
      video.appendChild(source);
      videoContainer.appendChild(video);
      mediaWrapper.appendChild(videoContainer);
      slide.appendChild(mediaWrapper);
      sliderComponent.appendChild(slide);
      
      // Add play button
      const playButton = document.createElement('button');
      playButton.className = 'video-control-button';
      playButton.innerHTML = '<span class="visually-hidden">Play video</span>';
      videoContainer.appendChild(playButton);
      
      playButton.addEventListener('click', function() {
        videoContainer.setAttribute('hidden', '');
        video.play();
      });
    }
    setActiveMedia(activeMedia) {

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }
    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

          document.querySelectorAll('.atc-button-price-container').forEach(el => el.textContent = this.currentVariant ? this.formatPrice(this.currentVariant.price) : '');

        })
        .catch((error) => {
          console.error('Failed to refresh product info', error);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            //submitButtonText.textContent = window.theme.variantStrings.addToCart;
            submitButtonText.childNodes[0].textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          // Product thumbnails
          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          // Product images
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.querySelector('product-slider').onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
    
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) {
        idInput.disabled = false;
      }
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }


    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

document.addEventListener('DOMContentLoaded', function() {
  const copyLinks = document.querySelectorAll('.copy-link');
  copyLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const currentUrl = window.location.href;
      const textSpan = this.querySelector('span:not(.icon)');
      const originalText = textSpan ? textSpan.textContent : '';
      
      navigator.clipboard.writeText(currentUrl)
        .then(() => {
          if (textSpan) {
            textSpan.textContent = 'Copied!';
            
            // Set timeout to restore original text
            setTimeout(() => {
              textSpan.textContent = originalText;
            }, 2000);
          }
        })
        .catch(err => {
          console.error('Failed to copy URL: ', err);
        });
    });
  });
});

function calculateDeliveryDate(orderDate = new Date()) {
  const deliveryDate = new Date(orderDate);
  
  deliveryDate.setDate(deliveryDate.getDate() + 1);
  
  const dayOfWeek = deliveryDate.getDay();
  
  if (dayOfWeek === 6) {
    deliveryDate.setDate(deliveryDate.getDate() + 2);
  }
  else if (dayOfWeek === 0) {
    deliveryDate.setDate(deliveryDate.getDate() + 1);
  }
  
  return deliveryDate;
}

function formatDeliveryDate(date) {
  const options = { weekday: 'long', month: 'long', day: 'numeric' };
  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
}

const today = new Date();
const deliveryDate = calculateDeliveryDate(today);

// Shipping popup logic removed — handled by jpc-free-shipping.liquid inline script